import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';

const DoorTypesPopupContent = props => {
  const { dimensions } = props;
  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);

  const [state, setState] = useState({
    isSliding: null,
    isHinged: null,
    loaded: false,
  });

  useEffect(() => {
    if (!state.loaded) {
      let isSliding = dimensions.width.hasOwnProperty(1);
      let isHinged = dimensions.width.hasOwnProperty(2);
      setState({ ...state, loaded: true, isSliding: isSliding, isHinged: isHinged });
    }
    /* eslint-disable-next-line */
  }, [wardrobesConfigs, activeWardrobe]);

  return (
    <div className="pop-up__content">
      <p className="pop-up__content-item">
        Rodzaj drzwi różni się w zależności od szerokości korpusu:
      </p>
      <p className="pop-up__content-item">Szafy o głębokości 66cm:</p>
      {state.isHinged && (
        <p className="pop-up__content-paragraph">
          <span>Drzwi Uchylne:</span> 50 cm; 75 cm (drzwi: 25/50 cm); 100 cm (drzwi: 50/50 cm).
        </p>
      )}
      {state.isSliding && (
        <p className="pop-up__content-paragraph pop-up__content-paragraph--big-margin">
          <span>Drzwi Przesuwne:</span> 120 cm; 150 cm; 170 cm; 180 cm; 200 cm; 220 cm; 240 cm; 260
          cm (każda szafa ma parę równych drzwi)
        </p>
      )}
      <p className="pop-up__content-item">Szafy o głębokości 45cm:</p>
      {state.isHinged && (
        <p className="pop-up__content-paragraph">
          <span>Drzwi Uchylne:</span> 50 cm; 75 cm (drzwi: 25/50 cm); 100 cm (drzwi: 50/50 cm).
        </p>
      )}
      {state.isSliding && (
        <p className="pop-up__content-paragraph">
          <span>Drzwi Przesuwne:</span> 120 cm; 150 cm, 170cm, 180 cm, 200 cm, 220cm, 240cm, 260cm
          (każda szafa ma parę rówynch drzwi).
        </p>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    dimensions: state.dimensions.dimensions,
  };
};

export default connect(mapStateToProps, null)(DoorTypesPopupContent);
